import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";

export function AuthLayout() {
  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "background.default",
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 440, width: "100%", p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom textAlign="center">
          Flat Rock Events Admin
        </Typography>
        <Outlet />
      </Card>
    </Box>
  );
}
